import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { get } from 'react-hook-form';
import { sanitizeAutoComplete } from './sanitize-auto-complete';

export type NumberInputProps = Partial<Omit<TextFieldProps, 'variant'>> & {
  errors?: Record<string, any>;
  inputRef: React.Ref<unknown>;
  helperText?: string;
  name: string;
  variant?: 'outlined' | 'standard' | 'filled';
};

export const NumberInput: React.FC<NumberInputProps> = ({
  errors,
  name,
  helperText,
  defaultValue,
  variant = 'outlined',
  ...rest
}) => {
  const error = get(errors, name);
  let label = rest.label || '';
  if (typeof label === 'string' && rest.required && label.match(/\s\*$/)) {
    label = label.replace(/\s\*$/, '');
  }
  const autoComplete = sanitizeAutoComplete(rest.autoComplete);

  return (
    <TextField
      error={Boolean(error) || errors?.isError}
      helperText={error?.message || helperText}
      fullWidth
      variant={variant}
      name={name}
      type="text"
      inputMode="numeric"
      defaultValue={defaultValue}
      InputProps={{
        ...(rest.InputProps || {}),
      }}
      inputProps={{
        ...rest.inputProps,
        pattern: '([0-9]*[.,])?[0-9]+',
      }}
      label={label}
      {...rest}
      autoComplete={autoComplete}
    />
  );
};
